// Modern B2B Platform Theme Configuration
// Configurable color system - update these values to change the entire theme

export const themeColors = {
  // Primary Blue Palette — matched to Vocative logo indigo-blue
  primary: {
    50: '#EDEEFF',
    100: '#D6D9FF',
    200: '#B0B6FF',
    300: '#8490F0',
    400: '#5A68E8',
    500: '#3B4DD6',  // Main brand color
    600: '#2E3EC0',
    700: '#2231A8',
    800: '#172590',
    900: '#0E1870',
  },

  // Neutral Grays
  neutral: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // Semantic Colors
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
  '3xl': 64,
};

export const borderRadius = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
};

export const shadows = {
  none: 'none',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.02)',
  md: '0 4px 12px -2px rgba(0, 0, 0, 0.08), 0 2px 6px -1px rgba(0, 0, 0, 0.04)',
  lg: '0 12px 24px -4px rgba(0, 0, 0, 0.12), 0 6px 12px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 24px 48px -8px rgba(0, 0, 0, 0.18), 0 12px 24px -4px rgba(0, 0, 0, 0.08)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  focus: '0 0 0 3px rgba(59, 77, 214, 0.12)',
  glow: '0 0 0 1px rgba(59, 77, 214, 0.1), 0 4px 16px -2px rgba(59, 77, 214, 0.2)',
};
